import { ChefHat, Utensils, Wine, Leaf, Star } from "lucide-react";

export const CUISINE_OPTIONS = [
  { id: "classic-french", label: "Classic French", icon: ChefHat },
  { id: "avant-garde", label: "Avant-garde", icon: Star },
  { id: "norwegian", label: "Norwegian", icon: Utensils },
  { id: "plant-based", label: "Plant-based", icon: Leaf },
  { id: "sauce-focused", label: "Sauce-focused", icon: Wine },
  { id: "japanese", label: "Japanese", icon: Utensils },
  { id: "italian", label: "Italian", icon: ChefHat },
  { id: "spanish", label: "Spanish", icon: Utensils },
  { id: "fusion", label: "Fusion", icon: Star },
  { id: "molecular", label: "Molecular Gastronomy", icon: Star }
];

export const SAUCE_OPTIONS = [
  "Béarnaise", "Hollandaise", "Beurre blanc", "Demi-glace",
  "Velouté", "Jus", "Red wine reduction", "Truffle cream",
  "Ponzu", "Teriyaki", "Chimichurri", "Romesco", "Pesto"
];

export const DISH_SUGGESTIONS = [
  "Foie Gras", "Lobster", "Wagyu Beef", "Caviar", "Truffle Risotto",
  "Sea Urchin", "Langoustine", "Duck Confit", "Soufflé", "Tartare",
  "Oysters", "Scallops", "Lamb", "Venison", "Tuna Tataki", "Beef Tenderloin"
];

export const DRINK_SUGGESTIONS = [
  "Champagne", "Burgundy", "Bordeaux", "Sake", "Natural Wine",
  "Cocktails", "Whisky", "Grappa", "Digestifs", "Riesling",
  "Pinot Noir", "Barolo", "Prosecco", "Gin & Tonic", "Negroni"
];

export const DESSERT_SUGGESTIONS = [
  "Chocolate Soufflé", "Crème Brûlée", "Tarte Tatin", "Mille-feuille",
  "Petit Fours", "Cheese Selection", "Sorbet", "Tiramisu",
  "Panna Cotta", "Macarons", "Lava Cake", "Cheesecake", "Profiteroles"
];

export const DIETARY_RESTRICTIONS = [
  "Vegetarian", "Vegan", "Gluten-free", "Lactose-free", "Nut allergy",
  "Shellfish allergy", "Halal", "Kosher", "Pescatarian", "Low-carb",
  "No pork", "No alcohol", "Egg allergy", "Soy-free"
];

export const BUDGET_LEVELS = [
  { value: 1, label: "€", description: "Bis 50€" },
  { value: 2, label: "€€", description: "50-100€" },
  { value: 3, label: "€€€", description: "100-200€" },
  { value: 4, label: "€€€€", description: "200€+" }
];
